export default {"src":"/_next/static/media/tucan.white.b94dca83.svg","height":50,"width":149,"blurWidth":0,"blurHeight":0};